import {
    Line,
    mixins
} from 'vue-chartjs'
import ChartjsPluginAnnotation from 'chartjs-plugin-annotation'
import DefaultOptions from '../DefaultOptions'

export default Line.extend({
  props: ['chartData', 'options'],
  mixins: [mixins.reactiveProp],
  components: {
    ChartjsPluginAnnotation
  },
  watch: {
    'options': {
      handler: function (newData, oldData) {
        this.defaultOptions.annotation.annotations = []
        let options = Object.assign({}, DefaultOptions, this.defaultOptions, newData)
        this.renderChart(this.chartData, options)
      }
    },
    'data': {
      handler: function (newData, oldData) {
        let options = Object.assign({}, DefaultOptions, this.defaultOptions, this.options)
        this.renderChart(newData, options)
      }
    }
  },
  data () {
    return {
      defaultOptions: {
        annotation: {
          drawTime: 'beforeDatasetsDraw',
          events: ['mouseover'],
          dblClickSpeed: 350,
          type: 'line',
          annotations: []
        }
      }
    }
  },

  mounted () {
    let options = Object.assign({}, DefaultOptions, this.defaultOptions, this.options)
    this.renderChart(this.chartData, options)
  }
})



// WEBPACK FOOTER //
// ./src/components/vuestic-components/vuestic-chart/chart-types/LineChart.js